// BasedStation.jsx
import React from 'react';
import HeroSection from './HeroSection';
import StatsSection from './StatsSection';
import Footer from './Footer';
import './BasedStation.css';
import VideoScene from './VideoScene';
import StakeDetails from './StakeDetails';

const BasedStation = () => {
  return (
    <div className="based-station" data-theme="dark">
      <div className="gradient-bg" />
      <HeroSection />
      <StatsSection />
      <StakeDetails />
      <VideoScene />
      <Footer />
    </div>
  );
};

export default BasedStation;